import { render, staticRenderFns } from "./PositionCorrectObject.vue?vue&type=template&id=6ba8719a&scoped=true&"
import script from "./PositionCorrectObject.vue?vue&type=script&lang=ts&"
export * from "./PositionCorrectObject.vue?vue&type=script&lang=ts&"
import style0 from "./PositionCorrectObject.vue?vue&type=style&index=0&id=6ba8719a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8719a",
  null
  
)

export default component.exports